import { Text_Transformer } from './TextTransformer';
import { getActiveProfiles, getProfiles } from './profiles';
import { Achord } from './Achord';
import MessageComponent from '$Chat/Message.svelte';
import SeparatorComponent from '$Chat/Separator.svelte';
import type { AchordData } from 'src/app';

const announcements =
	`
-- 7 days ago
captain: We just shipped v1.40 of Achord with many improvements! 🚀
-- 6 days ago
sil: Hey everyone! We're preparing chatbot releases for the upcoming release of Achord. If you spot any bugs please report them to #devchat!
-- 5 days ago
biz: We just crossed the 1'000'000$ MRR mark! 🥳 Great work everyone involved!
sil: On that note - special thanks to our devs for their continuous improvements in code quality. We couldn't be this agile without all our clean code efforts.
-- 3 days ago
captain: We just shipped v1.41 of Achord! You can check out the available chatbots by typing <code>/bots</code> in chat!🚀
-- 2 days ago
chill: g
sil: @chill you okay?
unklear: @chill cat on your desk again 😉 ?
chill: 😹
-- Yesterday
biz: We've partnered with Bumblr to create an premium integration. @captain Can we get that shipped next week?
unklear: What's Bumblr?
biz: Bumblr is a social media platform for people to share and discover new things.
unklear: That's so cool!
`;

const weheartmoney =
	`
-- 7 days ago
biz: Yeah, we'll throw an event and get the partnership sorted.
unklear: You sure it'll work?
biz: Nothing that a fancy dinner with good G&T can't solve.
-- 6 days ago
biz: @sil can you hop on a call with me and Bumblr? We're going to need a pair of developer eyes on this.
sil: @biz I'll be there. Something in the works?
biz: Yeah, we're working on a partnership.
captain: Did I hear ship?
biz: Partner-ship.
captain: Partial-ship?
biz: Sthaaap.
captain: Ha, that gives me an idea, I'll need to ping #devchat about this.
-- Yesterday


`;

const devchat =
	`
-- 9 days ago
chill: I can't believe jQuery is still a think.
sil: yeah
chill: but why
sil: It's not actually that bad you know
chill: ?
sil: People like to blame jQuery for all their woes. But the problem actually is that devs don't spend enough time designing their apps and just want to move fast.
-- 7 days ago
sil: Remember RoR?
dev: Yeah?
sil: We should build that but for Deno.
dev: That would be quite a feat.
-- 6 days ago:
captain: Hey! I just got a brilliant idea!
unklear: ... does it have something to do with shipping?
captain: More than you know! 😆
captain: We could develop a chatbot that could post random dad jokes!
dev: I LOVE DAD JOKES!
unklear: +1
sil: My dad joke cap is reached already with you around @captain.
captain: nono, this'll be great.
captain: And we can probably ship it quite quickly too.
sil: Ok, put it on the board and we can chat about it next meeting.
-- 3 days ago
dev: Working on a quick n dirty prototype, hopefully this works.
sil: Just don't forget to clean it up afterwards
dev: don't worry, we don't have to ship until we're ready
captain: I disagree. If you don't ship before you're ready, you've waited too long.
dev: What if it doesn't work?
captain: That might get in the way.
-- Yesterday
dev: ok, it's working
captain: 🚢
dev: But it's pretty rough around the edges.
captain: 🚢
dev: You sure?
captain: Yeah
dev: k
`;


const wip =
	`
-- 7 days ago
dev: 1.40 is out!
captain: When are we shipping 1.41?
dev: I'm working on it.
sil: @captain we'll ping you. Any particular concerns?
captain: nope, just checking in - we haven't shipped anything for a while.
-- 5 days ago
dev: test
captain: how goes it?
dev: It's not responding
dev: /bot
dev: /bots
bot: Hello?
dev: Finally!
bot: I think I'm sentient.
dev: Oh don't you start that.
dev: /uninstall bot
bot: <em>whimper</em>
dev: Ok, this'll need more work.
sil: What's that about.
dev: It's like it has a mind of its own. Seriously. I'm not sure what I'm missing, maybe I just need to start from scratch.
sil: Did you write up the tests?
dev: nope.
sil: I'm not against starting from scratch, if you also add tests.
dev: I know, I know. I'll see what I can do.
sil: ok.
-- 3 days ago
dev: /bot
bot: I wish I could clean mirrors for a living. It's just something I can see myself doing.
sil: lol
dev: /bot
bot: Q: What do you know about atoms? A: Very little.
dev: Ok, prototype ready. No bots were harmed in the making of this.
bot: undefined
dev: oh come on!
-- Yesterday
dev: /bot
bot: I wish I could clean mirrors for a living. It's just something I can see myself doing.
dev: Ok, I think it works now.
`;


const watercooler =
	`
-- 6 days ago
dev: It's been 14 seconds since a new JS framework was born
-- 4 days ago
sil: Did you hear? Devon Tusk is buying Bitter!
captain: Haha. Layzos buys a newspaper and Tusk buys Bitter. What's next? Gill Fence is going to buy Lategram? 🤣
dev: I bet he's going to rename it to B121++tEr :D
captain: ?
dev: He likes to call things in funny names.
sil: I wonder what the impact is going to be on the social media landscape
dev: He'll finally be able to ban the guy who tracked his airplane 🤣
captain: 🤣
-- 3 days ago
unklear: Just finished "Show your work" by Austin Kleon. This was exactly what I needed. It's full of quotes from a lot of creative people.
captain: Oh, I've read that. It's exactly why I think we should ship everything as soon as possible. Early feedback is invaluable.
sil: Yeah it's easy to get stick in your own head - at some point you just have to ship. Although, @captain you sometimes are a bit too ship-happy if you know what I mean :P
captain: Ship happy?
sil: You know, like trigger happy, just with shipping
captain: Oh hahah, yes, I ship happy :D
-- Yesterday
dev: Found a cool LPT on rebbit -  Buy a set of rechargeable AA and AAA batteries.
dev: They're actually really cheap these days - you'll save some money and reduce waste.
sil: Yep, I have a bunch already - everything is rechargeable in my house.
-- Today
sil: Major kudos to the team. We managed to refactor the entire codebase using design patterns.
dev: I'm glad we did. It was an amazing learning experience and the code is just so much easier to work with.
sil: I hope we keep writing code this way. Both innovation and maintainability are significantly easier now - we can experiment with new features much more easily.
dev: yup
dev: We should start a blog about this.
sil: I'm down
dev: Hm. The first obligatory step at this point is buying a domain, right?
sil: Definitely. You can't start a new side-project without a domain name.
dev: How about OnWritingCode.com ?
sil: Oh, I like that - it plays off the name of "On Writing Well".
dev: That book is a great resource for writing.
unklear: +1
dev: I'm going to do it. Maybe some day I'll actually write content for it.
sil: I'm sure it won't take you longer than 5 years.
dev: Absolutely. Probably more like 2 or 3 years.
sil: Go for it.
`;



const testing =
	`
-- New Channel Created
dev: testing
dev: testing again
dev: /bot
dev: /bot test
dev: /bot test again
dev: /bot test again again
dev: why is this not working?
dev: help. @Sil? Any ideas?
sil: did you run the post-deploy script to bust all caches?
dev: oh, right, I always forget...
dev: /bot
dev: Oh there we go,
dev: /bot
`;

function insert(app: Achord, entry: AchordData.Entry[], channel: string) {
	entry.forEach((entry) => {
		const component = getEntryComponent(entry);
		app.insert(component, entry, channel);
	});
}

function fill(app: Achord, channel: string, text: string, offset: number) {
	app.createChannel(channel);
	const entries = new Text_Transformer(text, offset).entries;
	insert(app, entries, channel)
}

function getEntryComponent(entry: AchordData.Entry): AchordData.EntryComponent {
	const components = {
		message: MessageComponent,
		separator: SeparatorComponent,
	};

	if (entry.type in components) {
		return components[entry.type]
	}

	return MessageComponent;

}

export function setupApp(defaultChannel: string, text: string, timeOffset = 0) {


	const app = new Achord(defaultChannel);

	fill(app, 'announcements', announcements, 2);
	fill(app, 'weheartmoney', weheartmoney, 2);
	fill(app, 'devchat', devchat, 2);
	fill(app, 'wip', wip, 2);
	fill(app, 'watercooler', watercooler, 2);
	fill(app, 'testing', testing, 2);


	if (text && text.length > 0) {
		const chat = new Text_Transformer(text, timeOffset);
		insert(app, [{
			type: 'separator',
			text: "Unread Messages",
			style: "unread",
			protected: true,
		}], defaultChannel);
		insert(app, chat.entries, defaultChannel)

		const online = getActiveProfiles(chat.getParticipantNames());
		app.setOnline(online);
	} else {
		app.setOnline(getProfiles(['sil', 'biz', 'unklear', 'dev']));
	}


	return app;
}